module.exports = __webpack_public_path__ + "static/img/connect03.b9c10e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/connect03.gif
// module id = E+u7
// module chunks = 1